var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Transition, StateService } from "@uirouter/core";
import { PageTitleService } from "imagine-ui-ng-quick-start";
import { IpsMessageService } from "imagine-ui-ng-messaging";
import { SpaceService } from "../../service/space.service";
import { String as IpsString } from "typescript-string-operations";
import { NgForm } from "@angular/forms";
import { TemplateFormBase } from "../../../shared/templateFormBase";
var SpaceEditComponent = /** @class */ (function (_super) {
    __extends(SpaceEditComponent, _super);
    function SpaceEditComponent(spaceService, ipsMessage, $state, trans, translateService, pageTitleService) {
        var _this = _super.call(this) || this;
        _this.spaceService = spaceService;
        _this.ipsMessage = ipsMessage;
        _this.$state = $state;
        _this.trans = trans;
        _this.translateService = translateService;
        _this.pageTitleService = pageTitleService;
        return _this;
    }
    SpaceEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        var spaceId = Number(this.trans.params().id);
        var pageTitle = spaceId > 0 ? "EDIT_SPACE" : "CREATE_SPACE";
        this.breadCrumbLabel = pageTitle;
        this.pageTitleService.setTitle([pageTitle]);
        // Clear out current location, fill in defaults
        this.myspace = { Id: spaceId };
        // If we got an ID to load, load it.
        // If paramId is not a number it will evaluate to false
        if (spaceId > 0) {
            //Initial call to populate screen on load
            this.getSpace(spaceId);
        }
        else {
            this.loaded = true;
        }
        this.translateText();
        this.translateService.onLangChange.subscribe(function () { return _this.translateText(); });
        _super.prototype.setFormPristine.call(this, this.spaceForm);
    };
    SpaceEditComponent.prototype.translateText = function () {
        var _this = this;
        this.translateService.get(["ACCESSING_SPACE_INFO", "PROMPT_DELETE_BODY"]).subscribe(function (res) {
            _this.accessSpaceInfo = res["ACCESSING_SPACE_INFO"];
            _this.deleteBodyPrompt = res["PROMPT_DELETE_BODY"];
        });
    };
    //Private Functions
    SpaceEditComponent.prototype.deleteSpace = function () {
        var id = this.myspace.Id;
        return this.spaceService.delete(id);
    };
    SpaceEditComponent.prototype.getSpace = function (id) {
        var _this = this;
        this.loaded = false;
        this.promise = this.spaceService.get(id).then(function (response) {
            Object.assign(_this.myspace, response);
            _this.loaded = true;
        });
    };
    SpaceEditComponent.prototype.saveSpace = function () {
        var _this = this;
        var id = String(this.myspace.Id);
        if (id) {
            return this.spaceService.put(this.myspace).then(function (response) {
                _this.spaceForm.form.markAsPristine();
            });
        }
        else {
            return this.spaceService.post(this.myspace).then(function (response) {
                _this.spaceForm.form.markAsPristine();
            });
        }
    };
    // Public Functions used by view
    SpaceEditComponent.prototype.deleteSpacePrompt = function () {
        var _this = this;
        var translated = this.deleteBodyPrompt;
        translated = IpsString.Format(translated, this.myspace.Name);
        // "DELETE_SPACE_CONFIRMATION"
        return this.ipsMessage.confirmDelete({ body: translated, workFunction: function () { return _this.deleteSpace(); }, progressMessage: "DELETING" })
            .then(function (result) {
            if (result) {
                _this.$state.go("main.storeProfileSpace.search");
            }
        })
            .catch(function () {
            // rejection
        });
    };
    SpaceEditComponent.prototype.saveSpacePrompt = function () {
        var _this = this;
        return this.ipsMessage.waitForWork({ body: "SAVING", workFunction: function () { return _this.saveSpace(); }, progressMessage: "SAVING" }).then(function (result) {
            if (result) {
                _this.$state.go("main.storeProfileSpace.search");
            }
        });
    };
    return SpaceEditComponent;
}(TemplateFormBase));
export { SpaceEditComponent };
